import React from "react";

const DialogContext = React.createContext({
	dialog: {},
});

export default DialogContext;